import { makeObservable, observable, flow, computed } from "mobx";
import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import { Add } from "@/components/icons/IconMap";

import BrowseTargetsSchema from "@/areas/compliance/schemas/BrowseTargetsSchema";

export default class BrowseTargetsStore {
  loading = false;
  pagination = null;
  targets = [];

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      pagination: observable,
      targets: observable,
      actions: computed,
      load: flow,
    });

    this.parentStore = parentStore;
  }

  get actions() {
    const list = [];

    list.push({
      id: "compliance:targets:create",
      label: "New Deployment Target",
      onClick: () => this.parentStore.createTargetStore.show(),
      icon: Add,
      location: "primary",
      processing: this.parentStore.createTargetStore.processing,
      disabled: this.parentStore.createTargetStore.processing,
    });

    return list;
  }

  consume(target) {
    const index = this.targets.findIndex((e) => e.id === target.id);
    if (index !== -1) {
      this.targets.splice(index, 1, target);
      this.targets = [...this.targets];
    }
  }

  *load(query, options) {
    const parseResult = BrowseTargetsSchema.safeParse(query);
    if (!parseResult.success) {
      return parseResult;
    }
    try {
      this.loading = true;
      const response = yield api.post(ApiRoutes.forTargetSearch(), query);

      this.targets = response.data.items;
      this.pagination = {
        page: response.data.page,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
        pageSize: response.data.pageSize,
      };
      return { success: true, data: response.data };
    } catch (e) {
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
